module.exports = __webpack_public_path__ + "static/media/admin-portal-icon.2bb04f92.png";